import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contact.scss";
import Title from "../ui-components/title/title";
import ContactInfo from './contactInfo/contactInfo';
import ContactSocial from './contactInfo/contactSocial';
import Modal from '../contact-modal/Modal';

import ContactBackground from '../../assets/contact/bg.webp';

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      message: "",
      sending: false,
      successModal: false,
      errorModal: false,
    };
  }

  inputHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ sending: true });

    const { name, email, message } = this.state;

    fetch("https://api.mpl.events/submit-form", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ name, email, message })
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        this.showSuccessModal();
      })
      .catch(error => {
        console.error("Error al enviar el formulario:", error);
        this.showErrorModal();
      });
  };

  showSuccessModal = () => {
    this.setState({ successModal: true, sending: false });
    this.resetForm();
  };

  showErrorModal = () => {
    this.setState({ errorModal: true, sending: false });
    this.resetForm();
  };

  resetForm = () => {
    this.setState({ name: "", email: "", message: "" });
  };

  closeModal = () => {
    this.setState({ successModal: false, errorModal: false });
  };

  render() {
    let submitButtonRender = (
      <div className="small__button">
        <button aria-label="enviar mensaje" type="submit" value="Enviar Mensaje">
          Enviar Mensaje
        </button>
      </div>
    );
    if (this.state.sending) {
      submitButtonRender = (
        <div className="small__button sending-btn">
          <div className="flex-center">
            <div className="sbl-circ"></div>
          </div>
        </div>
      );
    }

    let modalRender = null;
    if (this.state.successModal) {
      modalRender = <Modal closeModal={this.closeModal} status="success" />;
    } else if (this.state.errorModal) {
      modalRender = <Modal closeModal={this.closeModal} status="error" />;
    }

    return (
      <div id="contact">
        {modalRender}
        <div className="wrapper">
          <Title title="CONTÁCTANOS" />
          <p className="font12">
            ¿Tienes dudas o necesitas más información? Escríbenos y nos pondremos en contacto contigo lo antes posible.
          </p>

          <Row className="padding40">
            <Col md={12} lg={6}>
              <form id="contact-form" onSubmit={this.handleSubmit}>
                <h4 className="font30 weight800 padding30">Envíanos un mensaje</h4>
                <input type="text" placeholder="Nombre" required name="name" value={this.state.name} onChange={this.inputHandler} />
                <input type="email" placeholder="Correo electrónico" required name="email" value={this.state.email} onChange={this.inputHandler} />
                <textarea
                  rows="6"
                  cols="50"
                  placeholder="Escribe tu mensaje aquí..."
                  required
                  name="message"
                  value={this.state.message}
                  onChange={this.inputHandler}
                ></textarea>
                {submitButtonRender}
              </form>
            </Col>
            <Col md={12} lg={6}>
              <div className="flex-center">
                <img src={ContactBackground} alt="Fondo de contacto" />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Contact;
